import * as React from 'react'

import { Box, Icon, dimensions } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'
import type { AddPositionNodeData } from 'modules/org_chart/models/NodeData'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { NODE_SIZE } from 'modules/org_chart/components/Node/constants'
import AddPositionModal from './AddPositionModal'
import Hint from './Hint'
import './index.styles.css'
interface Props {
  data: AddPositionNodeData
  x: number
  y: number
  refetch: () => void
}

function AddPosition({ data, x: rawX, y, refetch }: Props) {
  const { atsEnabled } = useAtsEnabled()
  const [isOpen, setIsOpen] = React.useState(false)
  const [isUpsellModalOpen, setIsUpsellModalOpen] = React.useState(false)

  const handleClick = () => {
    track(trackingEvents.orgChart.nodes.addPosition.click, { hasAts: atsEnabled })

    if (atsEnabled && data.hasPermissions) {
      setIsOpen(true)
    } else if (data.canRequestUpsell) {
      setIsUpsellModalOpen(true)
    }
  }

  const x = rawX + (NODE_SIZE[0] - 80) / 2

  return (
    <>
      <foreignObject
        style={{ overflow: 'visible' }}
        width={dimensions.s80}
        height={dimensions.s80}
        x={x}
        y={y}
      >
        <Box
          width="s80"
          height="s80"
          borderRadius={{ all: 'rel333' }}
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          className={'AddPosition_node'}
          onClick={handleClick}
        >
          <Icon.Medium icon="add" color="grey800" />
        </Box>
      </foreignObject>
      {isOpen && (
        <AddPositionModal
          managerId={data.managerId}
          onClose={() => setIsOpen(false)}
          refetch={refetch}
        />
      )}
      {isUpsellModalOpen && (
        <UpsellingKit.ProductModal
          isOpen={isUpsellModalOpen}
          onClose={() => setIsUpsellModalOpen(false)}
          requestSource="Org chart - Add position button"
          moduleRequested={AvailableModules.ats}
          requestReason={ValidReasons.MissingAddon}
          pageSource="org_chart"
        />
      )}
    </>
  )
}

AddPosition.Hint = Hint

export default AddPosition
